module.exports = __webpack_public_path__ + "img/left-leg_active.a8e6e92d.png";